import { registerPlugin } from '@capacitor/core';

export const nativePlatform = registerPlugin<{
  background(): Promise<{ backgrounded: boolean }>;
  exportProgress(options: { json: string }): Promise<{ saved: boolean; cancelled?: boolean; bytes?: number }>;
}>('WordHuliPlatform');

interface BackActions {
  blocked: () => boolean;
  cancelSelection: () => boolean;
  leaveFocus: () => boolean;
  returnToBoard: () => boolean;
  save: () => Promise<unknown>;
  background: () => Promise<unknown>;
}

/** Android dispatches this event; ordinary browser history is unaffected. */
export function installNativeBack(actions: BackActions): void {
  let leaving = false;
  window.addEventListener('wordhuli:back', event => {
    event.preventDefault();
    if (leaving || actions.blocked()) return;
    const dialog = Array.from(document.querySelectorAll<HTMLDialogElement>('dialog[open]')).at(-1);
    if (dialog) {
      // Give rewarded-ad cancellation its normal dismissed-without-reward path.
      if (dialog.dispatchEvent(new Event('cancel', { cancelable: true }))) dialog.close();
      return;
    }
    if (actions.cancelSelection() || actions.leaveFocus() || actions.returnToBoard()) return;
    leaving = true;
    void actions.save().catch(() => {}).then(() => actions.background()).catch(() => {}).finally(() => { leaving = false; });
  });
}
